import ShareProjectSvg from '../../../assets/share-project.svg?react';
import { IconProps } from '../../types/IconProps';

export function ShareProject({ size = 20, ...props }: IconProps) {
  return <ShareProjectSvg data-testid="share-project-icon" width={size} height={size} {...props} />;
}

export default ShareProject;
